import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LOG_CLUSTER_LANGUAGES } from "../../data/constants";
import useCustomSnackbar from "../../hooks/useCustomSnackbar";
import { copyUrlToClipboard } from "../../utils/API";
import { getDisclaimerText } from "../../utils/helper";
import { Tooltip } from "../UI";

const MapDisclaimer = ({ config, isModalBox }) => {
  const [openSnackbar] = useCustomSnackbar();
  const { t, i18n } = useTranslation("common");
  const activeModule = useSelector((state) => state.activeModule);

  const switchLogClusterLanguage = () => {
    if (LOG_CLUSTER_LANGUAGES.includes(i18n.language)) {
      return i18n.language;
    } else {
      return "en";
    }
  };

  const currYear = useMemo(() => new Date().getFullYear(), []);

  const PoweredBy = (
    <span style={{ whiteSpace: "nowrap" }}>
      {t("screen.information.version")} {process.env.REACT_APP_VERSION} |{" "}
      {t("screen.information.poweredBy", { 1: currYear })}
    </span>
  );

  const Disclaimer = (
    <Tooltip
      placement="top"
      showOnClick
      content={getDisclaimerText(config, activeModule, t)}
      maxWidth="400px"
      blurred
      isTooltip
      zIndex={21}
      wrapperStyles={{
        alignItems: "flex-start",
        maxWidth: "140px",
      }}
    >
      <span
        style={{
          color: "#5a5959",
          textDecoration: "underline",
          display: "inline-block",
        }}
      >
        {t("screen.information.disclaimer")}
      </span>
    </Tooltip>
  );

  const Terms = (
    <a
      target="_blank"
      style={{ color: "#5a5959", alignItems: "flex-start", maxWidth: "140px" }}
      href={`https://logcluster.org/${switchLogClusterLanguage()}/node/46899`}
    >
      {t("screen.information.terms")}
    </a>
  );

  const Privacy = (
    <a
      target="_blank"
      style={{ color: "#5a5959", alignItems: "flex-start", maxWidth: "140px" }}
      href={`https://logcluster.org/${switchLogClusterLanguage()}/privacy-policy`}
    >
      {t("screen.information.privacy")}
    </a>
  );

  const handleContactClick = (e) => {
    let blurTimeout;
    const onBlur = () => {
      // Most likely the email client opened
      window.removeEventListener("blur", onBlur);
      clearTimeout(blurTimeout);
      // Optionally show a message: "Email client opened"
    };

    window.addEventListener("blur", onBlur);

    // If blur doesn't happen in 2 seconds, assume mailto failed
    blurTimeout = setTimeout(() => {
      window.removeEventListener("blur", onBlur);
      copyUrlToClipboard(
        "global.logie@wfp.org",
        openSnackbar,
        t,
        t("screen.information.contactCopyEmail")
      );
      // Optionally show a fallback: "Couldn't open email client, address copied!"
      // Show a toast or alert here if you want
    }, 500);
  };

  const ContactUs = (
    <a
      style={{ color: "#5a5959", alignItems: "flex-start", maxWidth: "140px" }}
      href="mailto:global.logie@wfp.org"
      onClick={handleContactClick}
    >
      {t("screen.information.contact")}
    </a>
  );

  const mapStyles = !isModalBox
    ? {
        position: "fixed",
        backgroundColor: "#ffffffb3",
        backdropFilter: "blur(10px)",
        height: "10px",
        bottom: "0",
        right: "0",
        zIndex: 10,
        borderRadius: "4px 4px 0px 0px",
      }
    : {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };

  const wrapperStyles = isModalBox
    ? {
        gap: i18n.language === "ru" ? 5 : 15,
        width: "100%",
        // alignItems: "center",
        justifyContent: "center",
      }
    : { gap: 15 };

  return (
    <div
      style={{
        color: "var(--fontColor)",
        fontSize: "10px",
        padding: "2px 8px",
        ...mapStyles,
      }}
    >
      <div
        style={{
          display: "flex",
          ...wrapperStyles,
        }}
      >
        {PoweredBy}
        {Disclaimer}
        {Terms}
        {Privacy}
        {ContactUs}
      </div>
    </div>
  );
};

export default MapDisclaimer;
